module.exports = __webpack_public_path__ + "static/img/tourney.86ea4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tourney.jpg
// module id = XbTQ
// module chunks = 0